/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Snackbar, Divider, FormControlLabel, Checkbox } from "@material-ui/core";
import { ReflexContainer, ReflexSplitter, ReflexElement } from "react-reflex";
import { Alert } from "@material-ui/lab";

import uiConf from "../../config/uiConf";

import apiClient from "../../lib/common/apiClient";
import checkValidation from "../../lib/utils/checkValidation";
import checkConditionWithMsg from "../../lib/utils/checkConditionWithMsg";

import Dialog from "../dialog/functional/Dialog";
import DialogContent from "../dialog/functional/DialogContent";
import DialogTitle from "../dialog/functional/DialogTitle";
import DialogActionsOkCancel from "../dialog/functional/DialogActionsOkCancel";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import AutoForm from "../form/functional/AutoForm";
import DialogHeaderWithClose from "../dialog/functional/DialogHeaderWithClose";
import { makeStyles } from "@material-ui/styles";
import {debounce} from "lodash";
import getExpirationDate from "../../lib/utils/getExpirationDate";

const useStyles = makeStyles((theme) => ({
    keepOpenSwitch: {
        marginLeft: "8px"
    },
    label: {
        fontSize: "smaller",
        color: theme.palette.primary.text
    },
}));


function MomSysCreateStockTakingDialog ( props ) {

    const classes = useStyles();

    const { t } = useTranslation ();

    const [instance, setInstance] = useState ();
    const [formData, setFormData] = useState({});
    const [interaction, setInteraction] = useState(false);
    const [grid, setGrid] = useState();
    const [notification, setNotification] = useState({
        open: false,
        severity: "success",
        msg: "",
    });

    const [onSelect, setOnSelect] = useState();

    const [keepOpen, setKeepOpen] = useState(false);

    const {
        
        id,
        schema,
        lotNo,
        
        moveable,
        resizable,
        fullWidth,
        maxWidth,
        
        initialData,
        
        onClose,
        onInitialized,
        onSuccess,

        stockTakingId,
        selectMaterial,
        
        ...others
        
    } = props;

    useEffect(() => {

        (async () => {

            if (grid) {

                grid.selectionChanged.addHandler(debounce((grid, event) => {

                    if ( grid.selectedItems && grid.selectedItems[0] ) {

                        setOnSelect(grid.selectedItems[0]);
                        selectMaterial({materialCode : grid.selectedItems[0].materialCode, materialCodeVer : grid.selectedItems[0].materialCodeVer});

                    }

                }, 10));

                grid.itemsSourceChanged.addHandler(debounce((grid, event) => {


                    if ( grid.selectedItems && grid.selectedItems[0] ) {

                        setOnSelect(grid.selectedItems[0]);
                        selectMaterial({materialCode : grid.selectedItems[0].materialCode, materialCodeVer : grid.selectedItems[0].materialCodeVer});
                    }

                }, 10));

            }

        })();

    }, [grid]);

    useEffect ( () => {

        setFormData ( ( formData ) => {

            if(onSelect) {

                let newFormData = {
                    ...formData,
                    materialCode: onSelect.materialCode,
                    materialCodeVer: onSelect.materialCodeVer,
    
                };
    
                return newFormData;
            }


        } );

    }, [onSelect] );
    
    const checkItemValidataion = ( schema, formData ) => {

        for ( const column of schema.columns ) {

            let [valid, msg] = checkValidation ( "create", column, column.validation, formData[column.name] || "" );

            if ( !valid ) {

                nofifyWarning ( msg );
                return false;

            }
            
        }

        return true;

    }
    const nofifyWarning = (msg) => {

        console.warn (msg);

        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });

    };

    const notifyFailure = (msg) => {
        console.error ( msg );

        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });

    };

    const onDialogInitialized = ( instance ) => {

        setInstance(instance);

        if ( onInitialized ) {

            onInitialized ( instance );

        }

    };

    const onApiSuccess = (result) => {

        setKeepOpen((keepOpen) => {

            if (!keepOpen) {

                instance.hide();

            }

            return keepOpen;

        });

        if (onSuccess) {

            onSuccess(result.data);

        }

    };

    const onApiFailure = (reason) => {
        
        notifyFailure ( t ( "error.undefinedError", { reason: reason.response ? reason.response.data : JSON.stringify ( reason ) } ) );
    };

    const onOk = ( schema, formData ) => {

        if ( ! checkItemValidataion ( schema, formData ) ) {

            console.error ( "Form Validation Failed" );

            return;

        }

        if (schema.validation) {

            let [valid, msg] = checkConditionWithMsg(

                formData,
                schema.validation

            );

            if (!valid) {

                nofifyWarning ( t ( "warning.formDataValidationFail", { msg: msg } ) );
                return;

            }

        }

        // build base api url

        let url = `/api/MomSysUglStockTakingDetail/${stockTakingId}`;

        let apiData = { ...formData };
        let form = new FormData ();

        let json = {};
        let deleted = {};

        for ( const formItem in apiData ) {

            if ( schema.columnMap && schema.columnMap[formItem] && schema.columnMap[formItem].formItemType === "file" ) {

                deleted[formItem] = apiData[formItem].deletedFiles;
                    
                for ( const file of apiData[formItem].activeFiles ) {

                    if ( file.type === "url" ) continue;

                    form.append ( formItem, file.file );

                }

            } else {

                if ( apiData[formItem] !== undefined ) {

                    json[formItem] = apiData[formItem];

                }

            }

        }

        form.append ( "deleted", JSON.stringify ( deleted ) );
        form.append ( "json", JSON.stringify ( json ) );
        
        apiClient
            .post(url, form, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then((result) => onApiSuccess(result))
            .catch((reason) => onApiFailure(reason));

    }

    const onCancel = () => {

        setFormData(null);

        instance.hide();

    };

    const onChange = ( formData ) => {

        setFormData ( formData );

        setInteraction( true );

    }

    const onGridInitialized = ( grid ) => {

        grid.selectionMode = "Row";

        setGrid(grid);

    };

    const onCloseNotification = () => {

        setNotification( ( notification ) => {

            return ({...notification, open: false});

        } );

    };

    const onCloseDialog = () => {

        setInteraction ( false );

        if ( onClose ) {

            onClose ();

        }
        setFormData(() => {
            
            let newFormData = {}

            return newFormData;

        });
    }

    const checkKeepOpen = () => {

        return (
            <>
                <FormControlLabel
                    control={

                        <Checkbox
                            className={classes.keepOpenSwitch}
                            checked={keepOpen}
                            color="primary"
                            onChange={() => setKeepOpen((keepOpen) => (!keepOpen))}
                            name="checkKeepOpen"
                            size="small"
                        />
                    }
                    label={<span className={classes.label}>{t("term.keepDialogOpen")}</span>}
                />
                <div style={{ flexGrow: 1 }}></div>

            </>

        )

    }
    
    return (
        <Dialog
            id={id}
            moveable={moveable ? moveable : uiConf.dialogMoveable}
            resizable={resizable ? resizable : uiConf.dialogResizable}
            fullWidth={fullWidth ? fullWidth : uiConf.dialogFullWidth}
            maxWidth="md"
            onClose={onCloseDialog}
            onInitialized={onDialogInitialized}
            {...others}
        >

            <DialogHeaderWithClose>
                <DialogTitle>
                    { t ( "dialog.title.MomSysUglStockTakingDetail.createStock" ) }
                </DialogTitle>
            </DialogHeaderWithClose>

            <Divider />

            <DialogContent style={{padding: "0px", height: "350px"}}>

                <ReflexContainer orientation="vertical">

                    <ReflexElement flex={0.565} >

                        <BasicCrudScreenType
                            id="MomSysZvwMaterial"
                            headerTitle={t("tableName.MomSysZvwMaterial")}
                            view="MomSysZvwMaterial"
                            noExcel
                            embededInOtherScreenType
                            onInitialized={onGridInitialized}
                        />

                    </ReflexElement>
                    
                    <ReflexSplitter
                        style={{width: "1px",color:"lightgray"}}
                    />

                    <ReflexElement flex={0.435} >

                    <div
                        style={{
                            padding: "16px"
                        }}                    
                    >

                        <AutoForm
                            id={id}
                            schema={schema}
                            mode="edit"
                            initialData={formData}
                            onChange={onChange}
                            modifyFormDataCallback={(formData, name) => {
                                if (name === "manufacturedDate") {
                                    formData.expirationDate = getExpirationDate(
                                    onSelect.standardExpirationDate,
                                    new Date(formData.manufacturedDate)
                                    );
                                };
                            if (name === "qtyDueDiligence" || name === "price") {
                                formData.amount = Number(formData.qtyDueDiligence) * Number(formData.price);
                            }
                            }}
                        />

                    </div>

                    </ReflexElement>

                </ReflexContainer>

                <Snackbar
                        open={notification.open && notification.severity !== "success"}
                        autoHideDuration={uiConf.dialogNotifyAutoHideDuration}
                        onClose={onCloseNotification}
                >
                    <Alert
                        onClose={onCloseNotification}
                        variant="filled"
                        severity={notification.severity}
                    >

                        {notification.msg}

                    </Alert>

                </Snackbar>

            </DialogContent>

            <Divider />

            <DialogActionsOkCancel
                firstActionComponent = {checkKeepOpen}
                labels={[ t("common.add")]}
                buttonDisabled={[!interaction, false]}
                onOk={() => onOk(schema, formData)}
                onCancel={onCancel}
            />

        </Dialog>

    );

}

export default MomSysCreateStockTakingDialog;
